(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-collection"] && !Shopify.designMode) return;
  try {
    
  function initProductCollectionSliders(root) {
    var sliders = (root || document).querySelectorAll('[data-product-slider]');
    sliders.forEach(function (slider) {
      if (slider.dataset.sliderInitialized) return;
      slider.dataset.sliderInitialized = 'true';

      var track = slider.querySelector('[data-product-slider-track]');
      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-product-slide]'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-product-slider-dot]'));
      if (!track || !slides.length) return;

      function setActiveDot(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = parseInt(dot.dataset.slideIndex, 10);
          var target = slides[index];
          if (target) {
            track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          }
        });
      });

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var index = parseInt(entry.target.dataset.slideIndex, 10);
              setActiveDot(index);
            }
          });
        },
        { root: track, threshold: [0.6] }
      );

      slides.forEach(function (slide) {
        observer.observe(slide);
      });

      setActiveDot(0);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProductCollectionSliders(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    initProductCollectionSliders(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
